import React, {useState, useEffect} from 'react';
import { useWeb3 } from '@openzeppelin/network/react';

import { Web3ReactProvider } from '@web3-react/core'
import { Web3Provider } from '@ethersproject/providers'
import { useWeb3React } from '@web3-react/core'
import { InjectedConnector } from '@web3-react/injected-connector'

import {formatEther} from "@ethersproject/units";

import { Contract } from '@ethersproject/contracts'
import { isAddress } from '@ethersproject/address'

import useSWR from 'swr'

import GFCABI from '../abi/GameForCrypto.abi.json'

import { fetcher } from '../util/Fetcher.js';
import { creditWeiCost, smartContractAddress, availableEntryFees, baseURL } from '../util/Constants.js';

import { useGamesData } from '../hooks/useGamesData.js';
import { useContestsData } from '../hooks/useContestsData.js';

import { ViewSmartContractContest } from './ViewSmartContractContest.js';

import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    backgroundColor: theme.palette.background.paper,
    '& > *': {
        margin: theme.spacing(1),
        width: theme.spacing(16),
      },
  },
  paper: {
    padding: theme.spacing(4),
    margin: theme.spacing(4),
  },
  gridList: {
    flexWrap: 'nowrap',
    // Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
    transform: 'translateZ(0)',
  },
  title: {
    color: '#FFFFFF',
  },
  titleBar: {
    background:
      'linear-gradient(to top, rgba(0,0,0,0.7) 0%, rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
  },
}));

export const ViewContests = (props) => {

  const { account, library } = useWeb3React();

  const [hasInit, setHasInit] = useState(false);
  const [myContract, setMyContract] = useState(null);

  const [contestListData, setContestListData] = useState(null);
  const [selectedContestID, setSelectedContestID] = useState(null);

  const contestsData = useContestsData();

  const classes = useStyles();

  /*const { data: contestContractData, mutate } = useSWR(['0x8B86Efbe8E6f0D09511DE1AbC1C0663896acFEa2','memberAcctBalance'], {
      fetcher: fetcher(library, GFCABI),
    })*/

  useEffect(() => {
    if(library && !hasInit){
      const contract = new Contract(smartContractAddress, GFCABI, library.getSigner());
      setMyContract(contract);
      setHasInit(true);
    }
    
  },[library])

  useEffect(() => {

      if(contestsData.data){
          console.log(`contestsData.data`, contestsData.data);
          setContestListData(contestsData.data);
      }

  },[contestsData.data])

  const refreshEvents = () => {
 
    let fetchURL = `${baseURL}/checkContractEvents`;
  
    fetch(fetchURL,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then((res) => {
          console.log('completed refreshEvents');
        })
    }
  

  const handleSelectContest = (contestID) => {

    if(selectedContestID !== contestID){
      setSelectedContestID(contestID);
    }

  }

  const getContestIndex = (contestID) => {

      if(myContract !== null){
      console.log(myContract);
    
      myContract['getContestIndex'](contestID)
      .then(result => {
        console.log(`getContestIndex`, result);
      })
    
      
    }

  }

  const attemptJoinContest = (contestID) => {
    console.log('Attempt..', account, contestID);

    if(myContract !== null){
      console.log(myContract);
      
      myContract['addGamerToContest'](contestID)
      .then(result => {
        console.log(`addGamerToContest attempted`, result);
        refreshEvents();
      })
    
      
    }
  }

  const joinContestLocal =  (contestID) => {
      //gameValue, entryFeeValue, maxPlayersContest
      //Todo use gamerName or gamerHash

      let postData = {
          address: account,
          contestID: contestID,
      }

      let fetchURL = `${baseURL}/joinGamingContest`;

      console.log(`Post Data:`, postData);

      fetch(fetchURL,
          {
              method: 'POST',
              body: JSON.stringify(postData),
              headers: {
                  'Content-Type': 'application/json'
              }
          })
      .then((res) => {
          let retData = res.json();

          console.log(retData);

          retData.then((data) => {

              console.log('Inside Join Contest');
              console.log(data);
              if(data.status === 'success'){
                attemptJoinContest(contestID);
              }
          })
      })
  }

  const getEthPrice = () => {
    console.log('getEthPrice..');

    if(myContract !== null){
      console.log(myContract);
    
      myContract['getEthPrice']()
      .then(result => {
        console.log(`getEthPrice attempted`, (result.toNumber() / 100000000));
      })
    
      
    }
  }

  const requestContestStatus = (contestID) => {
    console.log('requestContestStatus..');

    if(myContract !== null){
      console.log(myContract);
    
      myContract['requestContestStatus'](contestID)//, {gasLimit: '2000000' })
      .then(result => {
        console.log(`requestContestStatus attempted`);
      })
    
      
    }
  }

  const getLastStatus = () => {
    console.log('getLastStatus..');

    if(myContract !== null){
      console.log(myContract);
    
      myContract['getLastStatus']()
      .then(result => {
        console.log(`getLastStatus attempted`, result);
      })
    
      
    }
  }

  const testAPIURL = (contestID) => {
    console.log('testAPIURL..');

    if(myContract !== null){
      console.log(myContract);
    
      myContract['requestContestURL'](contestID)
      .then(result => {
        console.log(`testAPIURL attempted`, result.data.toString());
      })
    
      
    }
  }

  const declareContestWinner = (contestID, winner, score) => {
    console.log('declareContestWinner..');

    let postData = {
            contestID: contestID,
            winner: winner,
            score: score,
        }
    
        let fetchURL = `${baseURL}/declareContestWinner`;

        console.log(`Post Data:`, postData);
    
        fetch(fetchURL,
            {
                method: 'POST',
                body: JSON.stringify(postData),
                headers: {
                    'Content-Type': 'application/json'
                }
            })
        .then((res) => {
            let retData = res.json();
    
            console.log(retData);
    
            retData.then((data) => {

                console.log('Inside ');
                console.log(data);
    
            })
        })
  }


  const displayContests = () => {
    let display = null;
    let entries = null;

    if(contestListData){
        entries = contestListData.map((contest) => {
            return (
                
                      <TableRow key={contest.NO_ID_FIELD}>
                        <TableCell align="left">
                          <Typography variant="p">
                          {contest.game}
                        </Typography></TableCell>
                        <TableCell align="left">
                          <Typography variant="p">
                          {contest.goalDesc}
                        </Typography></TableCell>
                        <TableCell align="left">
                          <Typography variant="p">
                          {contest.maxPlayers}
                        </Typography></TableCell>
                        <TableCell align="left">
                          <Typography variant="p">
                          {contest.entryFee}
                        </Typography></TableCell>
                        <TableCell align="left">
                          <Typography variant="p">
                          {contest.NO_ID_FIELD}
                        </Typography></TableCell>
                        <TableCell align="left">
                          <Typography variant="p">
                          {contest.status}
                        </Typography></TableCell>
                        <TableCell align="left">
                        <Button
                        variant={'outlined'}
                        onClick={() => {
                            //getContestIndex(contest.NO_ID_FIELD);
                            handleSelectContest(contest.NO_ID_FIELD);
                            //attemptJoinContest(contest.NO_ID_FIELD);
                        }}
                        > View Contest </Button>
                         </TableCell>
                      </TableRow>
                  
    
            )
        })
    }

    if(entries !== null){
        display = (
              <div>
              
              {selectedContestID &&
              <Paper elevation={3} style={{marginTop: 16, marginLeft: 14, marginRight: 14, paddingTop: 8}}>
              <ViewSmartContractContest contestID={selectedContestID} />

               <Button
                onClick={() => {
                    //getContestIndex(contest.NO_ID_FIELD);
                    //attemptJoinContest(selectedContestID);
                    joinContestLocal(selectedContestID);
                }}
                > Join Contest </Button>

                {/*<Button
                onClick={() => {
                    //getContestIndex(contest.NO_ID_FIELD);
                    declareContestWinner(selectedContestID,'0xC96b1a87F0a5899B538d42439020C1835f30BAc3', 420);
                }}
              > Declare Winner </Button>*/}

                <Button
                onClick={() => {
                    //getContestIndex(contest.NO_ID_FIELD);
                    requestContestStatus(selectedContestID);
                }}
                > Request Update </Button>

                <Button
                onClick={() => {
                    //getContestIndex(contest.NO_ID_FIELD);
                    getLastStatus();
                }}
                > Check Winner </Button>

                {/*<Button
                onClick={() => {
                    //getContestIndex(contest.NO_ID_FIELD);
                    testAPIURL(selectedContestID);
                }}
              > testAPIURL </Button>*/}
                </Paper>
              }
              <Paper elevation={3} style={{marginTop: 16, marginLeft: 14, marginRight: 14, paddingTop: 8}}>
              <Typography variant="h5">
              Gaming Contest Browser 
              </Typography> 
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Contest Game</TableCell>
                      <TableCell>Goal</TableCell>
                      <TableCell>Max Players</TableCell>
                      <TableCell>Entry Fee</TableCell>
                      <TableCell>ContestID</TableCell>
                      <TableCell>Status</TableCell>
                      <TableCell>Options</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                  {entries}
                  </TableBody>
                </Table>
              </TableContainer>
            
              </Paper>
              </div>
          )
    }

      return display;
  }

  return (
    <div>
    {displayContests()}
    </div>
  )

}